module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/mrt-icon-dc958f3874630585fffd8c84d77983fc.png";